import Card, { type CardProps } from '@mui/material/Card';

/** Bordered, flat surface. Elevation is reserved for things that float. */
export function AppCard(props: CardProps) {
  return <Card {...props} />;
}
